import { render, staticRenderFns } from "./point-order-detail-coupon.vue?vue&type=template&id=7f1c1752"
import script from "./point-order-detail-coupon.vue?vue&type=script&lang=js"
export * from "./point-order-detail-coupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports